import script from "./vipCardUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipCardUI.vue?vue&type=script&setup=true&lang=ts"

import "./vipCardUI.vue?vue&type=style&index=0&id=11f467f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f467f4"]])

export default __exports__